export default {
      id: "ic_sub_menu_arrow-usage",
      viewBox: "0 0 16 26",
      url: "/" + "images/icons.3.109.2.svg#ic_sub_menu_arrow-usage",
      toString: function () {
        return this.url;
      }
    }